<template>
    <div class="animated fadeIn">

        <b-alert show variant="primary" v-if="exportResult" v-html="exportResult"></b-alert>

        <b-tabs  nav-wrapper-class="w-40">
            <b-tab >
                <template slot="title">
                    <i class="icon-book-open"></i> Финансы
                </template>

                <p>
                    Отчет показывает список путевок за указанный период (по дате выезда) и финансовые показатели.
                </p>

                <b-form>

                    <b-form-group
                        label="Диапазон дат: "
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <b-form-group label="Город: " :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект: " :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Тип отчета: " :label-cols="3" :horizontal="false">
                        <b-form-select
                            :plain="true"
                            :options="reportTypes"
                            v-model="reportType"
                            value-field="id"
                            text-field="title"
                            requred
                        >
                        </b-form-select>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportAgentFinance"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>

                </b-form>
            </b-tab>
            <b-tab >
                <template slot="title">
                    <i class="icon-book-open"></i> Оплаты
                </template>

                <p>
                    Отчет показывает список оплат (поступлений) по путевкам за указанный период.
                </p>

                <b-form>

                    <b-form-group
                        label="Диапазон дат: "
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <b-form-group label="Город: " :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект: " :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportAgentPayments"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </b-form>
            </b-tab>
        </b-tabs>

        <br>

        <b-card v-if="reports.length">
            <ul>
                <li v-for="r in reports">
                    <a :href="r.report_url" target="_blank">{{r.report_title}}</a>
                </li>
            </ul>
        </b-card>

        <p>WID=2e44d00d-04a4-41df-b389-0a52bea61fc9</p>


    </div>
</template>

<script>
    import Vue from 'vue'
    import { functions } from '@/functions';
    import { functions_loaders } from '@/functions_loaders';
    import { functions_hotel } from '@/functions/hotel.js';
    import { functions_city } from '@/functions_city.js';
    import { functions_report } from '@/functions_report.js';
    import { Switch as cSwitch } from '@coreui/vue'
    import vSelect from 'vue-select'
    import {CONSTANTS} from '@/constants'

    export default {
        name: 'NsbAgentReports',
        mixins: [functions, functions_loaders, functions_hotel, functions_report, functions_city, ],
        components: {
            cSwitch,
            vSelect,
        },
        data: function () {
            return {
                date_range:null,
                hotel_id:null,
                city_id:null,
                reportTypes:[
                    {id:1, title:'Исполняемые и исполненные путевки'},
                    {id:2, title:'Аннулированные путевки'},
                ],
                reportType:1,

                exportResult: null,
                exportReport: null,
                exportUrl: null,
            }
        },
        methods: {
            _reportAgentFinance: function() {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportAgentFinance(this.date_range_start, this.date_range_end, this.city_id, this.hotel_id, this.report_type);
                });
            },

            _reportAgentPayments: function() {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportAgentPayments(this.date_range_start, this.date_range_end, this.city_id, this.hotel_id);
                });
            },

            resetDateRange: function() {
                this.date_range = null;
            },
        },
        computed: {
            date_range_start: function () {
                if (this.date_range !== null)
                    return new Date(this.date_range.start).toLocaleDateString()
                return null;
            },
            date_range_end: function () {
                if (this.date_range !== null)
                    return new Date(this.date_range.end).toLocaleDateString()
                return null;
            },
            _hotels: function () {
                let self = this;
                return this.hotels.filter(function(hotel) {
                    if (self.city_id) {
                        return hotel.t_city_id === self.city_id;
                    }
                    else {
                        return true;
                    }
                });
            },
        },
        created: function() {
            this.loadHotels();
            this.loadCities();
        },
    };
</script>

<style lang="scss">
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
